import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  configuration: null,
};

const slice = createSlice({
  name: 'global-configuration',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.configuration) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getGlobalConfigSuccess(state, action) {
      state.isLoading = false;
      state.configuration = action.payload;
      state.isInitializing = false;
    },

    updateGlobalConfigSuccess(state, action) {
      state.isLoading = false;
      state.configuration = action.payload;
    },
  },
});

export function getGlobalConfiguration() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/global-configurations');
      dispatch(slice.actions.getGlobalConfigSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export const { updateGlobalConfigSuccess } = slice.actions;

export default slice.reducer;
